// @ts-nocheck

export enum ClientType {
  ARCHITECT = "ARCHITECT",
  CUSTOMER = "CUSTOMER",
  INSTALLER = "INSTALLER",
  IPS_HOSTER = "IPS_HOSTER",
  RETAILER = "RETAILER",
  WINDOW_BUILDER = "WINDOW_BUILDER",
  SYSTEM_PROVIDER = "SYSTEM_PROVIDER",
}

export enum AppointmentRequestActionType {
  CONFIRM = "CONFIRM",
  REJECT = "REJECT",
}

export enum FormInputType {
  CHECK = "CHECK",
  DATE = "DATE",
  FILE = "FILE",
  PARENT = "PARENT",
  LABEL = "LABEL",
  RADIO = "RADIO",
  RATING = "RATING",
  TEXT = "TEXT",
}

export enum WinDoPassConfigType {
  CARD_POSITION_1 = "CARD_POSITION_1",
  CARD_POSITION_2 = "CARD_POSITION_2",
  CARD_POSITION_3 = "CARD_POSITION_3",
  CARD_POSITION_4 = "CARD_POSITION_4",
  CARD_POSITION_5 = "CARD_POSITION_5",
  CONTACT_ABOUT_US_ENABLED = "CONTACT_ABOUT_US_ENABLED",
  CONTACT_ADDRESS_ENABLED = "CONTACT_ADDRESS_ENABLED",
  CONTACT_COLOR = "CONTACT_COLOR",
  CONTACT_COLOR_ORIGIN = "CONTACT_COLOR_ORIGIN",
  CONTACT_EMAIL_ENABLED = "CONTACT_EMAIL_ENABLED",
  CONTACT_ENABLED = "CONTACT_ENABLED",
  CONTACT_IMAGE_ENABLED = "CONTACT_IMAGE_ENABLED",
  CONTACT_IMAGE_ORIGIN = "CONTACT_IMAGE_ORIGIN",
  CONTACT_INFO_ENABLED = "CONTACT_INFO_ENABLED",
  CONTACT_OFFICE_HOURS_ENABLED = "CONTACT_OFFICE_HOURS_ENABLED",
  CONTACT_PHONE_ENABLED = "CONTACT_PHONE_ENABLED",
  CONTACT_WEBSITE_ENABLED = "CONTACT_WEBSITE_ENABLED",
  PRODUCT_INFO_ENABLED = "PRODUCT_INFO_ENABLED",
  PRODUCT_INFO_IMAGE_ENABLED = "PRODUCT_INFO_IMAGE_ENABLED",
  PRODUCT_INFO_GENERAL_DATA_ENABLED = "PRODUCT_INFO_GENERAL_DATA_ENABLED",
  PRODUCT_INFO_PRODUCT_NAME_ENABLED = "PRODUCT_INFO_PRODUCT_NAME_ENABLED",
  PRODUCT_INFO_PRODUCT_YEAR_OF_CONSTRUCTION_ENABLED = "PRODUCT_INFO_PRODUCT_YEAR_OF_CONSTRUCTION_ENABLED",
  PRODUCT_INFO_PRODUCT_MEASUREMENTS_ENABLED = "PRODUCT_INFO_PRODUCT_MEASUREMENTS_ENABLED",
  PRODUCT_INFO_PRODUCT_ORDER_AND_ORDER_LINE_NUMBER_ENABLED = "PRODUCT_INFO_PRODUCT_ORDER_AND_ORDER_LINE_NUMBER_ENABLED",
  PRODUCT_INFO_PRODUCT_DESCRIPTION_ENABLED = "PRODUCT_INFO_PRODUCT_DESCRIPTION_ENABLED",
  PRODUCT_INFO_PRODUCT_PROFILE_SYSTEM_ENABLED = "PRODUCT_INFO_PRODUCT_PROFILE_SYSTEM_ENABLED",
  PRODUCT_INFO_PRODUCT_WOOD_TYPE_ENABLED = "PRODUCT_INFO_PRODUCT_WOOD_TYPE_ENABLED",
  PRODUCT_INFO_GLASS_ENABLED = "PRODUCT_INFO_GLASS_ENABLED",
  PRODUCT_INFO_GLASS_DESCRIPTION_ENABLED = "PRODUCT_INFO_GLASS_DESCRIPTION_ENABLED",
  PRODUCT_INFO_GLASS_HEIGHT_ENABLED = "PRODUCT_INFO_GLASS_HEIGHT_ENABLED",
  PRODUCT_INFO_GLASS_WIDTH_ENABLED = "PRODUCT_INFO_GLASS_WIDTH_ENABLED",
  PRODUCT_INFO_GLASS_DEPTH_ENABLED = "PRODUCT_INFO_GLASS_DEPTH_ENABLED",
  PRODUCT_INFO_GLASS_LONG_TEXT_ENABLED = "PRODUCT_INFO_GLASS_LONG_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SALES_TEXT_ENABLED = "PRODUCT_INFO_GLASS_SALES_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SHORT_TEXT_ENABLED = "PRODUCT_INFO_GLASS_SHORT_TEXT_ENABLED",
  PRODUCT_INFO_GLASS_SPECIAL_GLASS_01_ENABLED = "PRODUCT_INFO_GLASS_SPECIAL_GLASS_01_ENABLED",
  PRODUCT_INFO_GLASS_SPECIAL_GLASS_02_ENABLED = "PRODUCT_INFO_GLASS_SPECIAL_GLASS_02_ENABLED",
  PRODUCT_INFO_FILES_ENABLED = "PRODUCT_INFO_FILES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_ACCESSORIES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_ACCESSORIES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_APPOINTMENTS_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_APPOINTMENTS_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_BROCHURE_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_BROCHURE_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_CERTIFICATES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_CERTIFICATES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_COMPLAINT_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_COMPLAINT_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_GENERAL_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_GENERAL_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_WARRANTY_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_WARRANTY_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_GUARANTEES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_GUARANTEES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_OTHERS_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_OTHERS_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SERVICES_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SERVICES_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SKETCH_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SKETCH_ENABLED",
  PRODUCT_INFO_FILE_CATEGORY_SUSTAINABILITY_ENABLED = "PRODUCT_INFO_FILE_CATEGORY_SUSTAINABILITY_ENABLED",
  PRODUCT_DETAILS_ENABLED = "PRODUCT_DETAILS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_ENABLED",
  PRODUCT_DETAILS_ACCESSORIES_ENABLED = "PRODUCT_DETAILS_ACCESSORIES_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_CUSTOMER_TEXT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_CUSTOMER_TEXT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_HEIGHT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_HEIGHT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_NET_PRICE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_NET_PRICE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_NOTE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_NOTE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_QUANTITY_ENABLED = "PRODUCT_DETAILS_ACCESSORY_QUANTITY_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TEXT_LONG_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TEXT_LONG_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TEXT_SHORT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TEXT_SHORT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_TITLE_ENABLED = "PRODUCT_DETAILS_ACCESSORY_TITLE_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_WEIGHT_ENABLED = "PRODUCT_DETAILS_ACCESSORY_WEIGHT_ENABLED",
  PRODUCT_DETAILS_ACCESSORY_WIDTH_ENABLED = "PRODUCT_DETAILS_ACCESSORY_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENTS_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENTS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAMES_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAMES_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ALU_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ALU_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_WIDTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTINGS_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTINGS_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_TYPE_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_TYPE_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_TEXT_ENABLED",
  PRODUCT_DETAILS_FILES_ENABLED = "PRODUCT_DETAILS_FILES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_ACCEPTANCE_PROTOCOL_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_ACCESSORIES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_ACCESSORIES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_APPOINTMENTS_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_APPOINTMENTS_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_BROCHURE_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_BROCHURE_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_CERTIFICATES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_CERTIFICATES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_COMMERCIAL_DATA_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_COMPLAINT_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_COMPLAINT_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_GENERAL_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_GENERAL_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_WARRANTY_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_WARRANTY_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_GUARANTEES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_GUARANTEES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_INSTRUCTION_SHEET_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_OTHERS_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_OTHERS_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_PRODUCT_PREVIEW_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SERVICES_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SERVICES_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SKETCH_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SKETCH_ENABLED",
  PRODUCT_DETAILS_FILE_CATEGORY_SUSTAINABILITY_ENABLED = "PRODUCT_DETAILS_FILE_CATEGORY_SUSTAINABILITY_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASSES_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASSES_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DEPTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DEPTH_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DESCRIPTION_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DESCRIPTION_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_HEIGHT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_HEIGHT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_LONG_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_LONG_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SALES_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SALES_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SHORT_TEXT_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SHORT_TEXT_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_01_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_01_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_02_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_02_ENABLED",
  PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_WIDTH_ENABLED = "PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_WIDTH_ENABLED",
  RECYCLING_ACTION_ENABLED = "RECYCLING_ACTION_ENABLED",
  RECYCLING_ENABLED = "RECYCLING_ENABLED",
  RECYCLING_PARTNER_ENABLED = "RECYCLING_PARTNER_ENABLED",
  REQUEST_ENABLED = "REQUEST_ENABLED",
  SYSTEM_PROVIDER_ENABLED = "SYSTEM_PROVIDER_ENABLED",
  WINDOW_BUILDER_ACTION_ENABLED = "WINDOW_BUILDER_ACTION_ENABLED",
  WINDOW_BUILDER_ENABLED = "WINDOW_BUILDER_ENABLED",
  COLLECTION_PARTNER_ENABLED = "COLLECTION_PARTNER_ENABLED",
  FILES_ENABLED = "FILES_ENABLED",
}

export enum ScanStatusType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum SignatureType {
  CLIENT = "CLIENT",
  CONTRACTOR = "CONTRACTOR",
}

export enum AppointmentCalendarType {
  TEAM_CALENDAR = "TEAM_CALENDAR",
  TASK_CALENDAR = "TASK_CALENDAR",
}

export enum AppointmentSeriesRepetitionType {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export enum ScanType {
  QR = "QR",
  NFC = "NFC",
}

export enum AppointmentRequestStatusType {
  NOT_CONFIRMED = "NOT_CONFIRMED",
  CONFIRMED = "CONFIRMED",
  REJECTED = "REJECTED",
}

export enum SubscriptionType {
  WIN_DO_PASS = "WIN_DO_PASS",
  WIN_DO_WORKS = "WIN_DO_WORKS",
  WIN_DO_WORKS_LIGHT = "WIN_DO_WORKS_LIGHT",
}

export enum AppointmentType {
  DELIVERY = "DELIVERY",
  INSTALLATION = "INSTALLATION",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  OTHERS = "OTHERS",
  REMAINING_WORK = "REMAINING_WORK",
  SERVICE = "SERVICE",
  SICKNESS = "SICKNESS",
  VACATION = "VACATION",
}

export enum OrderType {
  DOCUMENTATION = "DOCUMENTATION",
  INTERNAL = "INTERNAL",
  MAINTENANCE = "MAINTENANCE",
  MEASUREMENT = "MEASUREMENT",
  OFFER = "OFFER",
  COMPLAINT = "COMPLAINT",
  PICKUP = "PICKUP",
  QUOTATION = "QUOTATION",
  REMAINING = "REMAINING",
  SERVICE = "SERVICE",
}

export enum Language {
  GERMAN = "GERMAN",
  ENGLISH = "ENGLISH",
  CZECH = "CZECH",
  SPANISH = "SPANISH",
  FRENCH = "FRENCH",
  ITALIAN = "ITALIAN",
  DUTCH = "DUTCH",
  POLISH = "POLISH",
  ROMANIAN = "ROMANIAN",
  RUSSIAN = "RUSSIAN",
  SERBIAN = "SERBIAN",
  SLOVAK = "SLOVAK",
  SLOVENIAN = "SLOVENIAN",
  UKRAINIAN = "UKRAINIAN",
}

export enum AppointmentUpdateType {
  THIS_ONLY = "THIS_ONLY",
  CURRENT_AND_FUTURE = "CURRENT_AND_FUTURE",
  ALL = "ALL",
}

export enum ClientConfigurationType {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  API_ERP_APPLICATION_KEY = "API_ERP_APPLICATION_KEY",
  COCKPIT_APP_BACKGROUND_COLOR = "COCKPIT_APP_BACKGROUND_COLOR",
  COCKPIT_APP_BRANDING_COLOR = "COCKPIT_APP_BRANDING_COLOR",
  COCKPIT_APP_LINK = "COCKPIT_APP_LINK",
  COCKPIT_APP_TEXT_COLOR = "COCKPIT_APP_TEXT_COLOR",
  COMPLAINT_APP_ANDROID_LINK = "COMPLAINT_APP_ANDROID_LINK",
  COMPLAINT_APP_IOS_LINK = "COMPLAINT_APP_IOS_LINK",
  CORE_VERSION = "CORE_VERSION",
  ERP_IMPORT_TIMESTAMP = "ERP_IMPORT_TIMESTAMP",
  ERP_UPLOAD_GENERATE_ACTIVE = "ERP_UPLOAD_GENERATE_ACTIVE",
  ERP_UPLOAD_GENERATE_CONDITION = "ERP_UPLOAD_GENERATE_CONDITION",
  ERP_UPLOAD_GENERATE_CONTAINER_TYPE = "ERP_UPLOAD_GENERATE_CONTAINER_TYPE",
  ERP_UPLOAD_GENERATE_MODE = "ERP_UPLOAD_GENERATE_MODE",
  ERP_UPLOAD_GENERATE_OBJECT_TYPE = "ERP_UPLOAD_GENERATE_OBJECT_TYPE",
  ERP_UPLOAD_GENERATE_ORDER_TYPE = "ERP_UPLOAD_GENERATE_ORDER_TYPE",
  ERP_UPLOAD_GENERATE_TYPE = "ERP_UPLOAD_GENERATE_TYPE",
  ERP_UPLOAD_MERGE_PROCESSID = "ERP_UPLOAD_MERGE_PROCESSID",
  ERP_UPLOAD_PROJECT_ADDRESS_TYPE = "ERP_UPLOAD_PROJECT_ADDRESS_TYPE",
  ERP_UPLOAD_TARGET = "ERP_UPLOAD_TARGET",
  ERP_UPLOAD_TOKEN = "ERP_UPLOAD_TOKEN",
  EXTERNAL_ACCEPTANCE = "EXTERNAL_ACCEPTANCE",
  INSTALLER_APP_ANDROID_LINK = "INSTALLER_APP_ANDROID_LINK",
  INSTALLER_APP_BRANDING_COLOR = "INSTALLER_APP_BRANDING_COLOR",
  INSTALLER_APP_IOS_LINK = "INSTALLER_APP_IOS_LINK",
  KLAES_ORDER_PROCESSING = "KLAES_ORDER_PROCESSING",
  MODEL_VERSION = "MODEL_VERSION",
  USE_TAG_WHITELIST = "USE_TAG_WHITELIST",
  VERSION_CURRENT = "VERSION_CURRENT",
  VERSION_NEXT = "VERSION_NEXT",
  VERSION_NEXT_DATE = "VERSION_NEXT_DATE",
  VERSION_NEXT_MESSAGE = "VERSION_NEXT_MESSAGE",
}

export enum InstanceType {
  ACCESSORY_FIELD_RULE = "ACCESSORY_FIELD_RULE",
  ACCESSORY_IGNORE_RULE = "ACCESSORY_IGNORE_RULE",
  APPOINTMENT = "APPOINTMENT",
  APPOINTMENT_CONFIG = "APPOINTMENT_CONFIG",
  APPOINTMENT_CONFIG_PROPERTY = "APPOINTMENT_CONFIG_PROPERTY",
  CLIENT = "CLIENT",
  CLIENT_CONFIGURATION = "CLIENT_CONFIGURATION",
  COMPONENT = "COMPONENT",
  COMPONENT_LABEL = "COMPONENT_LABEL",
  CONFIGURATION = "CONFIGURATION",
  CONTACT = "CONTACT",
  CONTAINER = "CONTAINER",
  CONTENT_CENTER = "CONTENT_CENTER",
  CONTENT_CENTER_TEXT = "CONTENT_CENTER_TEXT",
  DOCUMENTATION = "DOCUMENTATION",
  DOCUMENTATION_INPUT = "DOCUMENTATION_INPUT",
  ENTITY_GENERATOR = "ENTITY_GENERATOR",
  ENTITY_MERGER = "ENTITY_MERGER",
  ERP_CASEMENT = "ERP_CASEMENT",
  ERP_COVER_FRAME = "ERP_COVER_FRAME",
  ERP_DOCUMENT = "ERP_DOCUMENT",
  ERP_DOCUMENT_LINE = "ERP_DOCUMENT_LINE",
  ERP_GLASS = "ERP_GLASS",
  ERP_TIME = "ERP_TIME",
  ERP_TRANSFER = "ERP_TRANSFER",
  FILE = "FILE",
  FORM = "FORM",
  NOTE = "NOTE",
  ORDER = "ORDER",
  ORDER_LINE = "ORDER_LINE",
  ORDER_LABEL = "ORDER_LABEL",
  PARTNER_DATA = "PARTNER_DATA",
  PRODUCT = "PRODUCT",
  PRODUCT_LABEL = "PRODUCT_LABEL",
  PRODUCT_LANGUAGE = "PRODUCT_LANGUAGE",
  PROJECT = "PROJECT",
  RESOURCE = "RESOURCE",
  RULE = "RULE",
  TEAM = "TEAM",
  TEAM_MEMBER = "TEAM_MEMBER",
  TIME_RECORD = "TIME_RECORD",
  USER = "USER",
  VALUE_HELP = "VALUE_HELP",
  VALUE_HELP_TEXT = "VALUE_HELP_TEXT",
}

export enum AppointmentConfigPropertyType {
  APPOINTMENT_DESCRIPTION = "APPOINTMENT_DESCRIPTION",
  APPOINTMENT_PARTNERS = "APPOINTMENT_PARTNERS",
  APPOINTMENT_RESOURCES = "APPOINTMENT_RESOURCES",
  APPOINTMENT_TEAMS = "APPOINTMENT_TEAMS",
  APPOINTMENT_TYPE = "APPOINTMENT_TYPE",
  APPOINTMENT_TYPE_ICON = "APPOINTMENT_TYPE_ICON",
  APPOINTMENT_USERS = "APPOINTMENT_USERS",
  ASSIGNED_TO = "ASSIGNED_TO",
  CUSTOMER_ADDRESS = "CUSTOMER_ADDRESS",
  DELIVERY_ADDRESS = "DELIVERY_ADDRESS",
  INTERNAL_ORDER_STATUS = "INTERNAL_ORDER_STATUS",
  OBJECT_CONTACT = "OBJECT_CONTACT",
  OBJECT_NUMBER = "OBJECT_NUMBER",
  OBJECT_TITLE = "OBJECT_TITLE",
  ORDER_ACCEPTANCE_STATUS = "ORDER_ACCEPTANCE_STATUS",
  ORDER_CONTACT = "ORDER_CONTACT",
  ORDER_CONTACT_PERSON_TELEPHONE = "ORDER_CONTACT_PERSON_TELEPHONE",
  ORDER_CONTACT_PERSON_EMAIL = "ORDER_CONTACT_PERSON_EMAIL",
  ORDER_DESCRIPTION = "ORDER_DESCRIPTION",
  ORDER_LABELS = "ORDER_LABELS",
  ORDER_NUMBER = "ORDER_NUMBER",
  ORDER_STATUS = "ORDER_STATUS",
  ORDER_TITLE = "ORDER_TITLE",
  ORDER_TYPE = "ORDER_TYPE",
  TOUR_NUMBER = "TOUR_NUMBER",
}

export interface OrderInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  OrderDetail?: Order | null;
  PermissionDetail?: OrderPermission | null;
}

export interface Form {
  Language_Value: string | null;
  Description: string | null;
  IsUsedForOrder: boolean | null;
  Title: string | null;
  Guid: string | null;
  Category_Id: string | null;
  Category_Value: string | null;
  Language_Id: string | null;
  SignatureRequired: boolean;
  InstanceGuid: string | null;
  ContainerType_Id: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  ContainerType_Value: string | null;
  TemplateGuid: string | null;
  CreatedOn: string | null;
  VariantGuid: string | null;
  Type_Value: string | null;
  IsUsedForOrderLine: boolean | null;
  Type_Id: string | null;
  OrderLineDetails?: Array<OrderLine>;
  SignatureDetails?: Array<FormSignature>;
  ClientDetail?: Client | null;
  FormProductCategoryDetails?: Array<FormProductCategory>;
  FormLanguageDetails?: Array<FormLanguage>;
  FormFormTypeDetails?: Array<FormFormType>;
  FormInputDetails?: Array<FormInput>;
}

export interface ApplicationConfig {
  UpdatedBy: string | null;
  TypeId: string;
  Description: string | null;
  CreatedBy: string | null;
  IsActive: boolean | null;
  TypeValue: string;
  Value: string;
  UpdatedOn: string | null;
  Guid: string | null;
  CreatedOn: string | null;
}

export interface Product {
  Description: string | null;
  Language_Value: string | null;
  CreatedBy_ClientGuid: string | null;
  ExtType: string | null;
  WarrantyTill: string | null;
  Guid: string | null;
  GuaranteeTill: string | null;
  UomId: string | null;
  Name: string | null;
  ExtText: string | null;
  ClientGuid: string | null;
  WarrantyFrom: string | null;
  UpdatedOn: string | null;
  ContainerType_Value: string | null;
  Height: number | null;
  ERPDocumentLineGuid: string | null;
  CreatedOn: string | null;
  ERPCustomerText: string | null;
  ContainerGuid: string | null;
  Width: number | null;
  GuaranteeFrom: string | null;
  Condition: string | null;
  IssuedToClientGuid: string | null;
  Title: string | null;
  ERPFilesUploaded: number | null;
  IssuedToUserGuid: string | null;
  OrderId: string | null;
  Category_Id: string | null;
  ImageFileGuid: string | null;
  Category_Value: string | null;
  ERPCoverFrameNumber: number | null;
  Language_Id: string | null;
  ERPDocumentGuid: string | null;
  ContainerType_Id: string | null;
  Tag: string | null;
  ERPUploadId: string | null;
  UomValue: string | null;
  ImageFileDetail?: File | null;
  ProductLabelDetails?: Array<ProductLabel>;
  InstanceActionDetails?: Array<ProductInstanceAction>;
  OrderLineDetails?: Array<OrderLine>;
  ProjectDetails?: Array<Project>;
  ERPDocumentLineDetail?: ERPDocumentLine | null;
  ERPComponentDetails?: Array<Component>;
  FileMappingDetails?: Array<FileMapping>;
  ComponentDetails?: Array<Component>;
  PartnerDetails?: Array<ProductPartner>;
  ContainerDetail?: Container | null;
  ProductLanguageDetails?: Array<ProductLanguage>;
  ProductLabelMappingDetails?: Array<ProductLabelMapping>;
  PermissionDetails?: Array<ProductPermission>;
  ERPDocumentDetail?: ERPDocument | null;
  FileDetails?: Array<File>;
  DocumentationDetails?: Array<Documentation>;
  ClientDetail?: Client | null;
  ERPCoverFrameDetails?: Array<ERPCoverFrame>;
}

export interface ComponentPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ComponentPermissionAction>;
  ComponentDetail?: Component | null;
}

export interface ContainerPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ContainerPermission | null;
}

export interface FormInputLanguage {
  ParentId: string | null;
  Language_Value: string | null;
  Description: string | null;
  Position: number | null;
  Title: string | null;
  Guid: string | null;
  Sid: string | null;
  Language_Id: string | null;
  InstanceGuid: string | null;
  IsMandatory: number | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  VariantGuid: string | null;
  Type_Value: string | null;
  FormGuid: string | null;
  Type_Id: string | null;
  FormInputDetail?: FormInput | null;
}

export interface ClientPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ClientPermission | null;
}

export interface ERPCoverFrame {
  DesignTextAlu: string | null;
  DesignValueAlu: string | null;
  Language_Value: string | null;
  Design_Text: string | null;
  Type_Text: string | null;
  Guid: string | null;
  DesignExterior_Value: string | null;
  ReferenceGuid: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  DesignInterior_Text: string | null;
  Height: number | null;
  DesignInterior_Value: string | null;
  CreatedOn: string | null;
  Width: number | null;
  ElementId: string | null;
  IssuedToClientGuid: string | null;
  TypeValueAlu: string | null;
  IssuedToUserGuid: string | null;
  OrderId: string | null;
  Language_Id: string | null;
  Type: string | null;
  Design_Value: string | null;
  IssuedToClientTitle: string | null;
  DesignExterior_Text: string | null;
  DocumentLineId: string | null;
  TypeTextAlu: string | null;
  ProductDetails?: Array<Product>;
  ERPFittingDetails?: Array<ERPFitting>;
  ERPCasementDetails?: Array<ERPCasement>;
  ERPDocumentLineDetail?: ERPDocumentLine | null;
}

export interface AclClientModule {
  IssuedToClientGuid: string | null;
  ClientGuid: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  Sid: string | null;
  Type_Id: string | null;
  ClientDetail?: Client | null;
}

export interface Filter {
  IsDefault: number | null;
  IsDeleted: number | null;
  OrderBy_Type: string;
  CreatedBy_ClientGuid: string | null;
  DeletedOn: string | null;
  CreatedBy_UserGuid: string | null;
  Title: string;
  CreatedBy_UserFullname: string | null;
  Guid: string;
  IsPublic: number | null;
  InstanceType_Id: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  OrderBy_Field: string;
  InstanceType_Value: string;
  FilterPropertyDetails?: Array<FilterProperty>;
  FilterColumnDetails?: Array<FilterColumn>;
}

export interface AppointmentTeam {
  CreatedBy: string | null;
  TeamGuid: string;
  CreatedOn: string | null;
  Guid: string;
  AppointmentGuid: string;
  AppointmentDetail?: Appointment | null;
}

export interface TeamMember {
  DeletedBy: string | null;
  IssuedToClientGuid: string | null;
  Description: string | null;
  CreatedBy: string | null;
  CreatedBy_ClientGuid: string | null;
  TeamGuid: string | null;
  DeletedOn: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  UpdatedBy: string | null;
  IsTeamLead: boolean | null;
  InstanceGuid: string | null;
  InstanceType_Id: string | null;
  UpdatedOn: string | null;
  InstanceDescription: string | null;
  CreatedOn: string | null;
  InstanceTitle: string | null;
  InstanceType_Value: string | null;
  ResourceDetail?: Resource | null;
  TeamDetail?: Team | null;
  ClientDetail?: Client | null;
  UserDetail?: User | null;
  FileDetails?: Array<File>;
}

export interface AppointmentClient {
  CreatedBy: string | null;
  ClientGuid: string;
  CreatedOn: string | null;
  Guid: string;
  AppointmentGuid: string;
  RequestStatus: AppointmentRequestStatusType | null;
  AppointmentDetail?: Appointment | null;
}

export interface TimeRecordInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  TimeRecordDetail?: TimeRecord | null;
  PermissionDetail?: TimeRecordPermission | null;
}

export interface TimeRecordPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  TimeRecordDetail?: TimeRecord | null;
  ActionDetails?: Array<TimeRecordPermissionAction>;
}

export interface AppointmentResource {
  ResourceCategory_Id: string;
  ResourceCategory_Value: string;
  CreatedBy: string | null;
  Status_Id: string;
  ResourceDescription: string | null;
  ResourceTitle: string;
  CreatedOn: string | null;
  ResourceGuid: string;
  Guid: string;
  AppointmentGuid: string;
  Status_Value: string;
  AppointmentDetail?: Appointment | null;
}

export interface User {
  Zip: string | null;
  ClientTitle: string | null;
  UserFullname: string | null;
  HouseNumber: string | null;
  Language_Value: string | null;
  Description: string | null;
  Email: string | null;
  Telephone: string | null;
  IsActive: number | null;
  Country_Id: string | null;
  Guid: string | null;
  Country_Value: string | null;
  ActivationChangedOn: string | null;
  ClientGuid: string | null;
  Salutation_Id: string | null;
  ValidFrom: string | null;
  UpdatedOn: string | null;
  Street: string | null;
  CreatedOn: string | null;
  ActivationChangedBy: string | null;
  Type_Id: string | null;
  ErpCreator: string | null;
  Lastname: string | null;
  City: string | null;
  Mobile: string | null;
  Firstname: string | null;
  Language_Id: string | null;
  ImageFileGuid: string | null;
  Username: string | null;
  ValidTill: string | null;
  LastAccess: string | null;
  Fax: string | null;
  Salutation_Value: string | null;
  Type_Value: string | null;
  AppointmentDetails?: Array<Appointment>;
  UserConfigurationDetails?: Array<UserConfiguration>;
  RoleDetails?: Array<Role>;
  ClientDetail?: Client | null;
  ImageDetail?: File | null;
  AclUserEntityDetails?: Array<AclUserEntity>;
}

export interface ProjectPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ProjectDetail?: Project | null;
  ActionDetails?: Array<ProjectPermissionAction>;
}

export interface DocumentationSignature {
  TypeId: string;
  UpdatedBy: string | null;
  CreatedBy: string | null;
  DocumentationGuid: string;
  IsRequired: boolean;
  TypeValue: string;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  DocumentationDetail?: Documentation | null;
}

export interface DocumentationPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<DocumentationPermissionAction>;
  DocumentationDetail?: Documentation | null;
}

export interface ClientPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  ClientDetail?: Client | null;
}

export interface OrderPoolConfig {
  TypeId: string | null;
  UpdatedBy: string | null;
  Ranking: number | null;
  CreatedBy: string | null;
  UserGuid: string | null;
  TypeValue: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string | null;
}

export interface Subscription {
  Value: string | null;
  Guid: string | null;
}

export interface AccessType {
  UserType_Text: string | null;
  ClientType_Id: string | null;
  UserType_Id: string | null;
  UserType_Value: string | null;
  ClientType_Value: string | null;
  Guid: string | null;
}

export interface Tag {
  UpdatedByClientGuid: string | null;
  ProductGuid: string | null;
  IsActive: number | null;
  Charge: string | null;
  CreatedByClientGuid: string | null;
  Guid: string | null;
  CreatedDuringId: string | null;
  ClientGuid: string | null;
  RollNumber: string | null;
  SystemProviderGuid: string | null;
  Value: string | null;
  UpdatedOn: string | null;
  CreatedByUserGuid: string | null;
  CreatedOn: string | null;
  IsValid: number | null;
  CreatedDuringValue: string | null;
}

export interface LegalAgreementCore {
  DeletedBy: string | null;
  IsDeleted: boolean | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  DeletedOn: string | null;
  ContactPerson: string | null;
  Language: string | null;
  ContactPersonPhone: string | null;
  Guid: string;
  UpdatedBy: string | null;
  CompanyAddress: string | null;
  UpdatedOn: string | null;
  Company: string | null;
  CreatedOn: string | null;
  ContactPersonEmail: string | null;
}

export interface FormInputProp {
  Language_Id: string | null;
  DefaultValue: string | null;
  Language_Value: string | null;
  Description: string | null;
  InstanceGuid: string | null;
  Position: number | null;
  UpdatedOn: string | null;
  Title: string | null;
  CreatedOn: string | null;
  Guid: string | null;
  VariantGuid: string | null;
  FormInputGuid: string | null;
  FormInputDetail?: FormInput | null;
  FormInputPropLanguageDetails?: Array<FormInputPropLanguage>;
}

export interface Configuration {
  Counter: number | null;
  ClientGuid: string | null;
  IsActive: number | null;
  UserGuid: string | null;
  Value: string | null;
  ConfigurationDescription: string | null;
  UpdatedOn: string | null;
  Guid: string | null;
  CreatedOn: string | null;
  ApplicationId: string | null;
  ConfigurationId: string | null;
  ApplicationDescription: string | null;
  UserDetail?: User | null;
}

export interface File {
  Description: string | null;
  CreatedBy_ClientGuid: string | null;
  IsTrustedSource: boolean | null;
  Source_Id: string | null;
  Guid: string | null;
  MimeType: string | null;
  Name: string | null;
  Bytes: number | null;
  IsStored: number | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Type_Id: string | null;
  IssuedToClientGuid: string | null;
  CreatedBy: string | null;
  SystemId: string | null;
  CreatedBy_UserFullname: string | null;
  IssuedToUserGuid: string | null;
  KlaesId: string | null;
  Category_Id: string | null;
  IsSystemFileCategory: number | null;
  Category_Value: string | null;
  FileUrl: string | null;
  Source_Value: string | null;
  Previewable: boolean | null;
  ChangedOn: string | null;
  Type_Value: string | null;
  InstanceActionDetails?: Array<FileInstanceAction>;
  PermissionDetails?: Array<FilePermission>;
  FileMappingDetails?: Array<FileMapping>;
}

export interface PartnerData {
  IssuedToClientGuid: string | null;
  Description: string | null;
  CreatedBy: string | null;
  CreatedBy_ClientGuid: string | null;
  IsActive: number | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  CreatedBy_UserFullname: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  Property_Id: string | null;
  InstanceGuid: string;
  CreatedBy_UserLastname: string | null;
  Property_Value: string | null;
  IssuedToClientTitle: string | null;
  Value: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  InstanceActionDetails?: Array<PartnerDataInstanceAction>;
  PermissionDetails?: Array<PartnerDataPermission>;
  ClientDetail?: Client | null;
}

export interface ContainerPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ContainerPermissionAction>;
}

export interface TimeRecord {
  CreatedBy_ClientGuid: string | null;
  CreatedFor_UserLastname: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedFor_UserGuid: string | null;
  Guid: string | null;
  Minutes: number;
  UpdatedBy: string | null;
  InstanceGuid: string | null;
  CreatedBy_UserLastname: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedToClientGuid: string | null;
  Comment: string;
  CreatedBy: string | null;
  CreatedBy_ClientTitle: string | null;
  UserGuid: string | null;
  CreatedBy_UserEmail: string | null;
  IssuedToUserGuid: string | null;
  CreatedFor_UserFirstname: string | null;
  Date: string;
  CreatedFor_UserEmail: string | null;
  CreatedFor_ClientTitle: string | null;
  CreatedFor_ClientGuid: string | null;
  InstanceType_Id: string | null;
  IssuedToClientTitle: string | null;
  InstanceType_Value: string | null;
  OrderDetail?: Order | null;
  USerDetail?: User | null;
  InstanceActionDetails?: Array<TimeRecordInstanceAction>;
  OrderLineDetail?: OrderLine | null;
  DocumentationDetail?: Documentation | null;
  PermissionDetails?: Array<TimeRecordPermission>;
  ProductDetail?: Product | null;
}

export interface ERPAddress {
  Zip: string | null;
  Description: string | null;
  Email: string | null;
  Language_Value: string | null;
  Address02: string | null;
  Telephone: string | null;
  Address01: string | null;
  Country_Id: string | null;
  Guid: string | null;
  Country_Value: string | null;
  Housenumber: string | null;
  Remark: string | null;
  ReferenceGuid: string | null;
  Agent04: string | null;
  Agent03: string | null;
  InstanceGuid: string | null;
  SalutationText: string | null;
  ClientGuid: string | null;
  Salutation_Id: string | null;
  LanguageText: string | null;
  ClientId: string | null;
  UpdatedOn: string | null;
  Street: string | null;
  CreatedOn: string | null;
  Agent02: string | null;
  Agent01: string | null;
  Type_Id: string | null;
  ClientIdInternal: string | null;
  IssuedToClientGuid: string | null;
  CountryText: string | null;
  Lastname: string | null;
  IssuedToUserGuid: string | null;
  City: string | null;
  OrderId: string | null;
  Firstname: string | null;
  Language_Id: string | null;
  IssuedToClientTitle: string | null;
  Region: string | null;
  Fax: string | null;
  Salutation_Value: string | null;
  Type_Value: string | null;
  ERPDocumentDetail?: ERPDocument | null;
}

export interface Order {
  Zip: string | null;
  Email: string | null;
  CreatedBy_ClientGuid: string | null;
  Status_Id: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  Country_Id: string | null;
  Latitude: number | null;
  Guid: string | null;
  ContactPerson: string | null;
  Status_Value: string | null;
  UpdatedBy: string | null;
  OriginGuid: string | null;
  TourNumber: string | null;
  UpdatedBy_UserFirstname: string | null;
  AssignedOn: string | null;
  ClientGuid: string | null;
  CreatedBy_UserLastname: string | null;
  Street: string | null;
  UpdatedOn: string | null;
  ContactPersonEmail: string | null;
  AssignedBy: string | null;
  Type_Id: string | null;
  CreatedBy: string | null;
  InternalStatusBackgroundColor: string | null;
  Lastname: string | null;
  OriginType_Value: string | null;
  AcceptanceStatus_Id: string | null;
  City: string | null;
  OriginType_Id: string | null;
  KlaesId: string | null;
  Longitude: number | null;
  PlannedTo: string | null;
  ERPDocumentGuid: string | null;
  HasAppointments: boolean | null;
  PlanningStatus_Value: string | null;
  UpdatedBy_UserLastname: string | null;
  AssignedTo_UserFullname: string | null;
  ClosedBy_UserLastname: string | null;
  ClosedBy_UserFirstname: string | null;
  Id: string | null;
  PlanningStatus_Id: string | null;
  ContactPersonTelephone: string | null;
  HouseNumber: string | null;
  Description: string | null;
  ProjectProcessId: string | null;
  ProjectPartnerGuid: string | null;
  ProjectClientGuid: string | null;
  InternalStatusText: string | null;
  Country_Value: string | null;
  AssignedBy_UserFullname: string | null;
  Phone: string | null;
  InternalStatusTextColor: string | null;
  CreatedOn: string | null;
  UpdatedBy_ClientTitle: string | null;
  IssuedToClientGuid: string | null;
  DeliveryAddressGuid: string | null;
  CreatedBy_ClientTitle: string | null;
  InternalStatusGuid: string | null;
  Title: string | null;
  CustomerAddressGuid: string | null;
  IssuedToUserGuid: string | null;
  AssignedTo: string | null;
  Firstname: string | null;
  ProjectTitle: string | null;
  ClosedOn: string | null;
  ClosedBy_ClientTitle: string | null;
  ProjectGuid: string;
  Type_Value: string | null;
  ClosedBy: string | null;
  AcceptanceStatus_Value: string | null;
  CustomerAddressDetail?: Address | null;
  ProductDetails?: Array<Product>;
  InstanceActionDetails?: Array<OrderInstanceAction>;
  AssignedToUserDetail?: User | null;
  OrderResourceDetails?: Array<OrderResourceMapping>;
  FileDetails?: Array<File>;
  FileMappingDetails?: Array<FileMapping>;
  OrderTeamDetails?: Array<OrderTeamMapping>;
  OrderLabelMappingDetails?: Array<OrderOrderLabelMapping>;
  ProjectDetail?: Project | null;
  OrderLineDetails?: Array<OrderLine>;
  PartnerDetails?: Array<OrderPartner>;
  InternalStatusDetail?: Array<InternalOrderStatus>;
  DeliveryAddressDetail?: Address | null;
  AppointmentDetails?: Array<Appointment>;
  TimeRecordDetails?: Array<TimeRecord>;
  PermissionDetails?: Array<OrderPermission>;
  OrderMappingDetails?: Array<OrderMapping>;
  OrderLabelDetails?: Array<OrderLabel>;
  OriginDocumentationDetail?: Documentation | null;
  ClientDetail?: Client | null;
  ContactDetails?: Array<Contact>;
  DocumentationDetails?: Array<Documentation>;
  NoteDetails?: Array<Note>;
}

export interface ProductTextPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ProductTextPermission | null;
}

export interface AccessoryFieldRule {
  CreatedBy: string | null;
  DependentArticleClass: number | null;
  DependentValue: string | null;
  CheckArticleClass: number;
  Guid: string | null;
  TargetEntityField: string | null;
  CheckValue: string | null;
  TargetEntity: string;
  CheckTypeValue: string;
  UpdatedBy: string | null;
  ClientGuid: string;
  UpdatedOn: string | null;
  CheckCode: string;
  DependentCode: number | null;
  CreatedOn: string | null;
}

export interface ContactInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ContactPermission | null;
  ContactDetail?: Contact | null;
}

export interface TeamPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: TeamPermission | null;
}

export interface AclUserEntity {
  UserGuid: string | null;
  InstanceType_Id: string | null;
  ClientType_Id: string | null;
  ClientType_Value: string | null;
  Guid: string | null;
  InstanceType_Value: string | null;
  ActionType_Value: string | null;
  ActionType_Id: string | null;
  UserDetail?: User | null;
}

export interface OrderPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  OrderDetail?: Order | null;
  ActionDetails?: Array<OrderPermissionAction>;
}

export interface ProductPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ProductPermissionAction>;
  ProductDetail?: Product | null;
}

export interface ProductPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  ProductDetail?: Product | null;
}

export interface ProductTextPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ProductLanguageDetail?: ProductLanguage | null;
  ActionDetails?: Array<ProductTextPermissionAction>;
}

export interface ComponentPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ComponentPermission | null;
}

export interface ERPTimeInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ERPTimePermission | null;
}

export interface OrderResourceMapping {
  ResourceCategory_Id: string | null;
  DeletedBy: string | null;
  OrderGuid: string | null;
  CreatedBy: string | null;
  ResourceCategory_ShortText: string | null;
  DeletedOn: string | null;
  ResourceTitle: string | null;
  Guid: string;
  ResourceGuid: string | null;
  OrderTitle: string | null;
  ResourceCategory_LongText: string | null;
  ResourceCategory_Value: string | null;
  UpdatedBy: string | null;
  ResourceDescription: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  OrderDetail?: Order | null;
  ResourceDetail?: Resource | null;
  FileDetails?: Array<File>;
}

export interface ResourcePermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ResourcePermissionAction>;
  ResourceDetail?: Resource | null;
}

export interface TimeRecordPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: TimeRecordPermission | null;
}

export interface Resource {
  IssuedToClientGuid: string | null;
  Description: string | null;
  CreatedBy: string | null;
  CreatedBy_ClientGuid: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  CreatedBy_UserFullname: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  KlaesId: string | null;
  Category_Id: string | null;
  UpdatedBy: string | null;
  Category_Value: string | null;
  ClientGuid: string | null;
  CreatedBy_UserLastname: string | null;
  IssuedToClientTitle: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  AppointmentDetails?: Array<Appointment>;
  TeamMemberDetails?: Array<TeamMember>;
  InstanceActionDetails?: Array<ResourceInstanceAction>;
  PermissionDetails?: Array<ResourcePermission>;
  OrderResourceDetails?: Array<OrderResourceMapping>;
  FileDetails?: Array<File>;
}

export interface Client {
  Zip: string | null;
  Email: string | null;
  SupportLink: string | null;
  Telephone: string | null;
  IsActive: boolean | null;
  Website: string | null;
  KlaesEmail: string | null;
  Guid: string | null;
  KlaesMandant: string | null;
  LogoFileGuid: string | null;
  ContactPerson: string | null;
  KlaesCompany: string | null;
  InformationLink: string | null;
  InvitedBy_ClientGuid: string | null;
  UpdatedBy: string | null;
  ActivationChangedOn: string | null;
  WinDoPassAgreementAccepted: boolean | null;
  Street: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  ContactPersonEmail: string | null;
  ActivationChangedBy: string | null;
  Type_Id: string | null;
  CreatedBy: string | null;
  Title: string | null;
  City: string | null;
  AddressGuid: string | null;
  KlaesPassword: string | null;
  Type_Value: string | null;
  ContactPersonTelephone: string | null;
  FormDetails?: Array<Form>;
  OrderDetails?: Array<Order>;
  AddressDetail?: Address | null;
  InstanceActionDetails?: Array<ClientInstanceAction>;
  SubscriptionDetails?: Array<Subscription>;
  PartnerDataDetails?: Array<PartnerData>;
  ProjectDetails?: Array<InstancePartnerProject>;
  ContentCenterDetails?: Array<ContentCenter>;
  ERPTokenDetails?: Array<ERPToken>;
  UserDetails?: Array<User>;
  FileMappingDetails?: Array<FileMapping>;
  PartnerDetails?: Array<ClientPartner>;
  AppointmentDetails?: Array<Appointment>;
  PermissionDetails?: Array<ClientPermission>;
  ClientConfigurationDetails?: Array<ClientConfiguration>;
  AclClientModuleDetails?: Array<AclClientModule>;
  FileDetails?: Array<File>;
  LogoDetail?: File | null;
}

export interface ERPDocumentLine {
  PositionInstallationCW: string | null;
  Language_Value: string | null;
  ProductName: string | null;
  SketchFileGuid: string | null;
  DeliveryDate: string | null;
  Guid: string | null;
  Unit: string | null;
  DowelSystem_Value: string | null;
  GlasPriceList_Text: string | null;
  CeMarking_Value: string | null;
  Remark: string | null;
  BaseBodyColor_Text: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  PositionInstallationDate: string | null;
  GuaranteeId: string | null;
  ShutterBoxSystem_Text: string | null;
  UpdatedOn: string | null;
  Version_Value: string | null;
  ProfileGroup: string | null;
  GasketColor_Value: string | null;
  LineId_Value: string | null;
  WoodType_Text: string | null;
  ColorNo_Value: string | null;
  VersionTextAlu: string | null;
  DrainageSystem_Value: string | null;
  PositionInstallationRemark: string | null;
  GasketSystem_Text: string | null;
  PurchaseRemark: string | null;
  OrderId: string | null;
  GlasPriceList_Value: string | null;
  TypeText: string | null;
  Weight: number | null;
  ClientItemNo: string | null;
  ProductNo_Value: string | null;
  ShutterHandlingSystem_Text: string | null;
  Language_Id: string | null;
  FittingGroup_Text: string | null;
  NetPrice: number | null;
  ShutterJalousieSystem_Text: string | null;
  ShutterJalousieSystem_Value: string | null;
  Note: string | null;
  ShutterSystem_Value: string | null;
  ProductNo_Text: string | null;
  DocumentLineId: string | null;
  CustomerText: string | null;
  InsectProtectionSystem_Value: string | null;
  ColorNo_Text: string | null;
  ShutterHandlingSystem_Value: string | null;
  Description: string | null;
  KindText: string | null;
  TypeTextLong: string | null;
  LineId_Text: string | null;
  DeliveryRemark: string | null;
  ReferenceGuid: string | null;
  FoldLamination: number | null;
  UWert: number | null;
  OrderLineTitle: string | null;
  Version_Text: string | null;
  DrainageSystem_Text: string | null;
  Height: number | null;
  DeliveryWeek: string | null;
  Division: string | null;
  CreatedOn: string | null;
  InsectProtectionSystem_Text: string | null;
  GasketColor_Text: string | null;
  ProfileGroup_Text: string | null;
  ShutterSystem_Text: string | null;
  Width: number | null;
  BuildNumbers: string | null;
  Condition: string | null;
  IssuedToClientGuid: string | null;
  GasketSystem_Value: string | null;
  WoodType_Value: string | null;
  ShutterBoxSystem_Value: string | null;
  VersionValueAlu: string | null;
  Amount: number | null;
  CeMarking_Text: string | null;
  Quantity: number | null;
  Service: number | null;
  IssuedToUserGuid: string | null;
  VersionGasket_Value: string | null;
  Architect_Text: string | null;
  DowelSystem_Text: string | null;
  BaseBodyColor_Value: string | null;
  IssuedToClientTitle: string | null;
  FittingGroup_Value: string | null;
  ProductDescription: string | null;
  ProfileGroup_Value: string | null;
  VersionGasket_Text: string | null;
  Type_Value: string | null;
  PdfFileGuid: string | null;
  Memo: string | null;
  ProductDetails?: Array<Product>;
  ERPTimeDetails?: Array<ERPTime>;
  ERPDocumentDetail?: ERPDocument | null;
  ERPCoverFrameDetails?: Array<ERPCoverFrame>;
}

export interface TeamInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: TeamPermission | null;
  TeamDetail?: Team | null;
}

export interface FilterProperty {
  IsDeleted: number | null;
  Property_Field: string;
  Property_Value: string;
  DeletedOn: string | null;
  Property_Type: string;
  Guid: string;
  FilterGuid: string;
  FilterDetail?: Filter | null;
}

export interface ComponentComponentLabelMapping {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  ComponentGuid: string;
  UpdatedOn: string | null;
  Guid: string;
  CreatedOn: string | null;
  ComponentLabelGuid: string;
  ComponentLabelDetail?: ComponentLabel | null;
  OrderDetail?: Component | null;
}

export interface NoteInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  NoteDetail?: Note | null;
  PermissionDetail?: NotePermission | null;
}

export interface AppointmentUser {
  CreatedBy: string | null;
  UserGuid: string;
  CreatedOn: string | null;
  Guid: string;
  AppointmentGuid: string;
  AppointmentDetail?: Appointment | null;
}

export interface Event {
  IssuedToClientGuid: string | null;
  CreatedBy: string | null;
  InstanceTypeType_Value: string | null;
  CreatedBy_ClientGuid: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  CreatedBy_UserFullname: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  InstanceGuid: string | null;
  InstanceTypeType_Id: string | null;
  CreatedBy_UserLastname: string | null;
  InstanceType_Id: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  InstanceType_Value: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  OrderDetail?: Order | null;
  ProjectDetail?: Project | null;
  OrderLineDetail?: OrderLine | null;
  TimeRecordDetail?: TimeRecord | null;
  DocumentationDetail?: Documentation | null;
  NoteDetail?: Note | null;
}

export interface InternalOrderStatusMapping {
  SourceGuid: string;
  DestinationGuid: string;
  Guid: string;
}

export interface ContactPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ContactPermission | null;
}

export interface FilePermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: FilePermission | null;
}

export interface NotePermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<NotePermissionAction>;
  NoteDetail?: Note | null;
}

export interface AppointmentOrderLine {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  UpdatedOn: string | null;
  OrderLineGuid: string;
  Guid: string;
  CreatedOn: string | null;
  AppointmentGuid: string;
  AppointmentDetail?: Appointment | null;
}

export interface CouplePositionIgnoreRule {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  Description: string;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  Guid: string | null;
  CreatedOn: string | null;
  ArticleClass: string;
}

export interface FormLanguage {
  IssuedToClientGuid: string | null;
  Description: string | null;
  Language_Value: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  Language_Id: string | null;
  InstanceGuid: string | null;
  ContainerType_Id: string | null;
  ClientGuid: string | null;
  IssuedToClientTitle: string | null;
  ContainerType_Value: string | null;
  UpdatedOn: string | null;
  TemplateGuid: string | null;
  CreatedOn: string | null;
  Type_Value: string | null;
  VariantGuid: string | null;
  Type_Id: string | null;
  FormDetail?: Form | null;
}

export interface DocumentationInput {
  FormInputDetailGuid: string | null;
  FormInputDetailDefaultValue: string | null;
  DocumentationGuid: string | null;
  DocumentationParentId: string | null;
  FormInputParentId: string | null;
  FormInputDescription: string | null;
  CheckedBy: string | null;
  FormInputDetailDescription: string | null;
  Status_Id: string | null;
  FormInputIsMandatory: number | null;
  FormInputClientGuid: string | null;
  PlannedBy: string | null;
  Guid: string | null;
  FormInputForAcceptance: number | null;
  FormInputGuid: string | null;
  Status_Value: string | null;
  Counter: number | null;
  IsMandatory: number | null;
  DocumentationParentGuid: string | null;
  UpdatedOn: string | null;
  FormInputPosition: number | null;
  FormInputType_Value: string | null;
  CreatedOn: string | null;
  FormGuid: string | null;
  ParentId: string | null;
  IssuedToClientGuid: string | null;
  IssuedToUserGuid: string | null;
  FormInputDetailPosition: number | null;
  PlannedOn: string | null;
  ClosedOn: string | null;
  Value: string | null;
  FileGuid: string | null;
  CheckedOn: string | null;
  ClosedBy: string | null;
  ChildrenDetails?: Array<DocumentationInput>;
  DocumentationDetail?: Documentation | null;
  FileDetails?: Array<File>;
  FileMappingDetails?: Array<FileMapping>;
}

export interface FileMapping {
  InstanceGuid: string | null;
  InstanceType_Id: string | null;
  FileGuid: string | null;
  Guid: string | null;
  KlaesId: string | null;
  InstanceType_Value: string | null;
  OrderDetail?: OrderLine | null;
  FileDetail?: File | null;
  DocumentationDetail?: Documentation | null;
  ComponentLabelDetail?: ComponentLabel | null;
  ProductDetail?: Product | null;
  ProductLabelDetail?: ProductLabel | null;
  ContentCenterDetail?: ContentCenter | null;
  ContentCenterTextViewDetail?: ContentCenterText | null;
  DocumentationInputDetail?: DocumentationInput | null;
  ProjectDetail?: Project | null;
  NoteDetail?: Note | null;
  ValueHelpDetail?: ValueHelp | null;
  ComponentDetail?: Component | null;
  ClientDetail?: Client | null;
}

export interface FormProductCategory {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  CreatedBy_UserLastname: string | null;
  CreatedBy_ClientGuid: string | null;
  ProductCategory_Id: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  ProductCategory_Value: string;
  FormGuid: string;
  FormDetail?: Form | null;
}

export interface ClientConfiguration {
  IsDeleted: number | null;
  IsActive: number | null;
  ConfigurationId: string | null;
  ApplicationDescription: string | null;
  Sid: string | null;
  ConfigurationTitle: string | null;
  ConfigurationImageName: string | null;
  Counter: number | null;
  ClientGuid: string | null;
  Value: string | null;
  ConfigurationDescription: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Type_Value: string | null;
  ApplicationId: string | null;
  Type_Id: string | null;
  ClientDetail?: Client | null;
}

export interface Component {
  ProductGuid: string | null;
  TextShort: string | null;
  CreatedBy_ClientGuid: string | null;
  WeightUOM_Id: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  ComponentGuid: string | null;
  Guid: string;
  IsAddition: number | null;
  QuantityUOM_Value: string | null;
  CreatedBy_UserLastname: string | null;
  UpdatedOn: string | null;
  WeightUOM_Value: string | null;
  Height: number | null;
  ERPDocumentLineGuid: string | null;
  TemplateGuid: string | null;
  CreatedOn: string | null;
  IsAlternative: number | null;
  IsDemand: number | null;
  Width: number | null;
  IsTemplate: number | null;
  IssuedToClientGuid: string | null;
  CreatedBy: string | null;
  CreatedBy_UserFullname: string | null;
  Quantity: number | null;
  Title: string | null;
  Currency_Id: string | null;
  IssuedToUserGuid: string | null;
  OrderId: string | null;
  QuantityUOM_Id: string | null;
  TextLong: string | null;
  Currency_Value: string | null;
  IsInternal: number | null;
  Weight: number | null;
  Category_Id: string | null;
  MeasurementUom: string | null;
  TranslationCount: number | null;
  Category_Value: string | null;
  ERPDocumentGuid: string | null;
  NetPrice: number | null;
  Note: string | null;
  IssuedToClientTitle: string | null;
  ProjectGuid: string | null;
  CustomerText: string | null;
  ERPUploadId: string | null;
  ComponentLanguageDetails?: Array<ComponentLanguage>;
  InstanceActionDetails?: Array<ComponentInstanceAction>;
  OrderLineDetails?: Array<OrderLine>;
  SubComponentDetails?: Array<Component>;
  ProductDetail?: Product | null;
  ERPDocumentLineDetail?: ERPDocumentLine | null;
  FileMappingDetails?: Array<FileMapping>;
  ProjectDetail?: Project | null;
  PermissionDetails?: Array<ComponentPermission>;
  ERPDocumentDetail?: ERPDocument | null;
  ComponentDetail?: Component | null;
  FileDetails?: Array<File>;
  NoteDetails?: Array<Note>;
  ComponentLabelDetails?: Array<ComponentComponentLabelMapping>;
}

export interface TagMetaData {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  SystemProviderGuid: string | null;
  Value: string;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string | null;
  TagGuid: string;
}

export interface FormFormType {
  FormType_Value: string;
  UpdatedBy: string | null;
  CreatedBy: string | null;
  FormType_Id: string | null;
  CreatedBy_UserLastname: string | null;
  CreatedBy_ClientGuid: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  FormGuid: string;
  FormDetail?: Form | null;
}

export interface TagMetaDataCore {
  DeletedBy: string | null;
  UpdatedBy: string | null;
  IsDeleted: boolean | null;
  CreatedBy: string | null;
  TagGuid: string;
  DeletedOn: string | null;
  UpdatedOn: string | null;
  Guid: string;
  CreatedOn: string | null;
}

export interface ContentCenter {
  CategoryId: string;
  CreatedBy: string | null;
  Description: string | null;
  IsActive: boolean | null;
  Title: string | null;
  Guid: string;
  CreatedByUserFullName: string | null;
  UpdatedByUserFullName: string | null;
  UpdatedBy: string | null;
  ClientGuid: string;
  ValidTill: string;
  UpdatedOn: string | null;
  ValidFrom: string;
  CategoryValue: string;
  CreatedOn: string | null;
  ContentCenterTextDetails?: Array<ContentCenterText>;
  ClientDetail?: Client | null;
  FileDetails?: Array<File>;
}

export interface OrderLabelText {
  UpdatedBy: string | null;
  Language_Id: string | null;
  CreatedBy: string | null;
  InstanceGuid: string | null;
  Language_Value: string | null;
  UpdatedOn: string | null;
  Text: string | null;
  CreatedOn: string | null;
  Guid: string | null;
  OrderLabelDetail?: OrderLabel | null;
}

export interface ErpTransfer {
  Status: string | null;
  ProcessStart: string | null;
  OrderGuid: string | null;
  Size: number | null;
  UserGuid: string;
  Guid: string | null;
  OrderId: string | null;
  Source: string | null;
  ProcessDuration: number | null;
  FactoryId: string | null;
  ClientGuid: string;
  ProcessEnd: string | null;
  ErpDocumentGuid: string | null;
  TagId: string | null;
  UpdatedOn: string | null;
  ProcessId: string | null;
  CreatedOn: string | null;
  ErrorMessage: string | null;
  IsChecked: boolean | null;
}

export interface UserRole {
  IsDeleted: number | null;
  Description: string | null;
  SystemId: string | null;
  Guid: string | null;
}

export interface ResourceInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  ResourceDetail?: Resource | null;
  PermissionDetail?: ResourcePermission | null;
}

export interface ERPGlass {
  SalesText: string | null;
  Description: string | null;
  Language_Value: string | null;
  Guid: string | null;
  Depth: number | null;
  CasementId: string | null;
  ReferenceGuid: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  Height: number | null;
  CreatedOn: string | null;
  LongText: string | null;
  Width: number | null;
  ElementId: string | null;
  IssuedToClientGuid: string | null;
  SpecialGlass02: string | null;
  SpecialGlass01: string | null;
  IssuedToUserGuid: string | null;
  GlasIdDrawing: string | null;
  OrderId: string | null;
  Language_Id: string | null;
  GlasId: string | null;
  ShortText: string | null;
  DocumentLineId: string | null;
  ERPCasementDetail?: ERPCasement | null;
}

export interface ERPToken {
  Sys_CreatedBy: string | null;
  Sys_UpdatedBy: string | null;
  ClientGuid: string | null;
  UserGuid: string | null;
  Sys_CreatedOn: string | null;
  Token: string | null;
  Guid: string;
  Sys_UpdatedOn: string | null;
  ClientDetail?: Client | null;
}

export interface Address {
  Zip: string | null;
  HouseNumber: string | null;
  Email: string | null;
  Description: string | null;
  SalutationId: string | null;
  Lastname: string | null;
  Country_Id: string | null;
  Latitude: number | null;
  Guid: string;
  City: string | null;
  KlaesId: string | null;
  Longitude: number | null;
  Country_Value: string | null;
  Remark: string | null;
  Firstname: string | null;
  SalutationValue: string | null;
  Phone: string | null;
  Street: string | null;
  Region: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
}

export interface InternalOrderStatus {
  UpdatedBy: string | null;
  CreatedBy: string;
  ClientGuid: string;
  CategoryText: string;
  UpdatedOn: string | null;
  Text: string;
  Guid: string;
  TextColor: string;
  CreatedOn: string;
  BackgroundColor: string;
  OrderDetails?: Array<Order>;
  DestinationDetails?: Array<InternalOrderStatus>;
}

export interface ProductPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ProductPermission | null;
}

export interface OrderMapping {
  UpdatedBy: string | null;
  OrderGuid: string;
  CreatedBy: string | null;
  InstanceGuid: string;
  UpdatedOn: string | null;
  Guid: string;
  CreatedOn: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  SourceOrderDetail?: Order | null;
  DestinationOrderDetail?: Order | null;
}

export interface ProductLabelMapping {
  ProductLabelGuid: string;
  UpdatedBy: string | null;
  ProductGuid: string;
  CreatedBy: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  ProductDetail?: Product | null;
  OrderLabelDetail?: ProductLabel | null;
}

export interface UserInvitationToken {
  InvitedByPartnerService: boolean | null;
  CreatedBy: string | null;
  NewUserSalutation_Id: string | null;
  ClientGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  UserType_Id: string | null;
  UserType_Value: string | null;
  NewUserEmail: string | null;
  Guid: string | null;
  ValidUntil: string | null;
  UpdatedBy: string | null;
  NewUserFirstname: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  NewUserLastname: string | null;
  NewUserSalutation_Value: string | null;
}

export interface ERPTimePermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ERPTimePermission | null;
}

export interface ContainerInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  ContainerDetail?: Container | null;
  PermissionDetail?: ContainerPermission | null;
}

export interface DocumentationPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: DocumentationPermission | null;
}

export interface Appointment {
  OrderGuid: string | null;
  Description: string | null;
  ProjectProcessId: string | null;
  Start: string | null;
  Status_Id: string | null;
  OrderAcceptanceStatus_Value: string | null;
  CreatedBy_UserGuid: string | null;
  OrderStatus_Value: string | null;
  Guid: string | null;
  OrderStreet: string | null;
  AppointmentGuid: string | null;
  OrderTitle: string | null;
  Status_Value: string | null;
  OrderCountry_Id: string | null;
  ClientGuid: string;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  UpdatedBy_ClientTitle: string | null;
  Type_Id: string | null;
  AppointmentSeriesGuid: string | null;
  OrderInternalStatusText: string | null;
  OrderCountry_Value: string | null;
  CreatedBy_ClientTitle: string | null;
  OrderDescription: string | null;
  CreatedBy_UserFullname: string | null;
  Title: string | null;
  TeamGuids: string | null;
  OrderCity: string | null;
  IssuedToUserGuid: string | null;
  KlaesId: string | null;
  OrderId: string | null;
  UpdatedBy_UserFullname: string | null;
  OrderHouseNumber: string | null;
  End: string | null;
  Type_Value: string | null;
  OrderType_Value: string | null;
  OrderZip: string | null;
  OrderDetail?: Order | null;
  InstanceActionDetails?: Array<AppointmentInstanceAction>;
  OrderLineDetails?: Array<OrderLine>;
  ResourceMappingDetails?: Array<AppointmentResource>;
  UserDetails?: Array<User>;
  UserMappingDetails?: Array<AppointmentUser>;
  ClientDetails?: Array<Client>;
  TeamMappingDetails?: Array<AppointmentTeam>;
  AppointmentDetails?: Array<Appointment>;
  TeamDetails?: Array<Team>;
  ResourceDetails?: Array<Resource>;
  ClientMappingDetails?: Array<AppointmentClient>;
  OrderLineMappingDetails?: Array<AppointmentOrderLine>;
}

export interface ClientSubscriptionMapping {
  ClientGuid: string | null;
  SubscriptionGuid: string | null;
  Guid: string | null;
}

export interface ERPTimePermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ERPTimePermissionAction>;
}

export interface ClientInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ClientPermission | null;
  ClientDetail?: Client | null;
}

export interface Upload {
  Status: string | null;
  FactoryId: string | null;
  ERPSource: string | null;
  Size: number | null;
  ERPVersion: string | null;
  ProcessId: string | null;
  CreatedOn: string | null;
  Guid: string;
  OrderId: string | null;
}

export interface ERPAddressDelivery {
  Zip: string | null;
  Language_Value: string | null;
  Email: string | null;
  Address02: string | null;
  Telephone: string | null;
  Address01: string | null;
  Guid: string | null;
  Country_Value: string | null;
  Housenumber: string | null;
  ReferenceGuid: string | null;
  Agent04: string | null;
  Agent03: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  SalutationText: string | null;
  ClientId: string | null;
  UpdatedOn: string | null;
  Street: string | null;
  CreatedOn: string | null;
  Agent02: string | null;
  Agent01: string | null;
  Type_Id: string | null;
  ClientIdInternal: string | null;
  IssuedToClientGuid: string | null;
  CountryText: string | null;
  Lastname: string | null;
  IssuedToUserGuid: string | null;
  City: string | null;
  OrderId: string | null;
  Firstname: string | null;
  Language_Id: string | null;
  Type_Value: string | null;
  Fax: string | null;
  ERPDocumentDetail?: ERPDocument | null;
}

export interface NotePermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: NotePermission | null;
}

export interface Documentation {
  ProductGuid: string | null;
  CheckedBy: string | null;
  CreatedBy_ClientGuid: string | null;
  Status_Id: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  FormClientGuid: string | null;
  FormTemplateGuid: string | null;
  Guid: string | null;
  PlannedBy: string | null;
  OrderTitle: string | null;
  Status_Value: string | null;
  IsServerManaged: number | null;
  SignatureRequired: boolean | null;
  AssignedOn: string | null;
  CreatedBy_UserLastname: string | null;
  UpdatedOn: string | null;
  AssignedBy: string | null;
  FormGuid: string | null;
  FormCategory_Id: string | null;
  CreatedBy: string | null;
  ClientGuidFrom: string | null;
  OrderId: string | null;
  PlannedOn: string | null;
  AssignedTo_UserFullname: string | null;
  FormObjectType_Value: string | null;
  FormDescription: string | null;
  OrderGuid: string | null;
  Description: string | null;
  FormType_Id: string | null;
  FormContainerType_Value: string | null;
  FormType_Value: string | null;
  OrderLineTitle: string | null;
  AssignedBy_UserFullname: string | null;
  ClientGuidTo: string | null;
  CreatedOn: string | null;
  ContainerGuid: string | null;
  IssuedToClientGuid: string | null;
  CreatedBy_ClientTitle: string | null;
  OrderLineGuid: string | null;
  IssuedToUserGuid: string | null;
  FormVisibility_Value: string | null;
  AssignedTo: string | null;
  Checked: boolean | null;
  ProjectTitle: string | null;
  ClosedOn: string | null;
  IssuedToClientTitle: string | null;
  TagId: string | null;
  FormCategory_Value: string | null;
  CheckedOn: string | null;
  ClosedBy: string | null;
  OrderDetail?: Order | null;
  ProductDetails?: Array<Product>;
  InstanceActionDetails?: Array<DocumentationInstanceAction>;
  OrderLineDetails?: Array<OrderLine>;
  ContainerDetails?: Array<Container>;
  ClosedByUserDetail?: User | null;
  ProjectDetails?: Array<Project>;
  FileMappingDetails?: Array<FileMapping>;
  PartnerDetails?: Array<DocumentationPartner>;
  SignatureDetails?: Array<DocumentationSignature>;
  FormDetails?: Form | null;
  TimeRecordDetails?: Array<TimeRecord>;
  PermissionDetails?: Array<DocumentationPermission>;
  DocumentationInputDetails?: Array<DocumentationInput>;
  FileDetails?: Array<File>;
  NoteDetails?: Array<Note>;
  CausedOrderDetails?: Array<Order>;
}

export interface Rule {
  CreatedBy: string | null;
  EntityAttribute_Id: string | null;
  EntityType_Id: string | null;
  Guid: string;
  UpdatedBy: string | null;
  EntityType_Value: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  EntityAttribute_Value: string | null;
  InstanceType_Id: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  InstanceType_Value: string | null;
  ComponentLabelDetail?: ComponentLabel | null;
  ProductLabelDetail?: ProductLabel | null;
  RuleOptionDetails?: Array<RuleOption>;
  ValueHelpDetail?: ValueHelp | null;
}

export interface AccessoryComponentRule {
  UpdatedBy: string | null;
  TypeId: string;
  Description: string | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  IsActive: boolean | null;
  TypeValue: string;
  Value: string;
  UpdatedOn: string | null;
  Guid: string | null;
  CreatedOn: string | null;
}

export interface FilterColumn {
  Order: string;
  UpdatedBy: string | null;
  CreatedBy: string | null;
  UpdatedOn: string | null;
  Title: string;
  Rank: number;
  Guid: string;
  FilterGuid: string;
  CreatedOn: string | null;
  FilterDetail?: Filter | null;
}

export interface PartnerDataPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: PartnerDataPermission | null;
}

export interface ProjectPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  ProjectDetail?: Project | null;
}

export interface AppointmentInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  AppointmentDetails?: Appointment | null;
  PermissionDetails?: AppointmentPermission | null;
}

export interface OrderLine {
  ProductGuid: string | null;
  ProductName: string | null;
  CreatedBy_ClientGuid: string | null;
  Status_Id: string | null;
  ComponentTextShort: string | null;
  SubType_Id: string | null;
  DeliveryDate: string | null;
  PlannedBy: string | null;
  Guid: string | null;
  InternalAcceptanceStatus_Value: string | null;
  OrderTitle: string | null;
  Status_Value: string | null;
  UpdatedBy: string | null;
  OriginGuid: string | null;
  UpdatedOn: string | null;
  FormGuid: string | null;
  ElementId: string | null;
  CreatedBy: string | null;
  DeliveryDescription: string | null;
  OriginType_Value: string | null;
  VersionTextAlu: string | null;
  CreatedBy_UserFullname: string | null;
  AcceptanceStatus_Id: string | null;
  OrderId: string | null;
  KlaesId: string | null;
  OriginType_Id: string | null;
  OrderType_Id: string | null;
  InstallationLocation: string | null;
  ERPDocumentGuid: string | null;
  ImageFileGuid: string | null;
  PlannedOn: string | null;
  OrderType_Value: string | null;
  OrderGuid: string;
  ClosedBy_UserFullname: string | null;
  Description: string | null;
  PositionElementPiece: string | null;
  SubType_Value: string | null;
  ProjectPartnerGuid: string | null;
  UoM_Value: string | null;
  ComponentGuid: string | null;
  PieceId: string | null;
  InternalAcceptanceStatus_Id: string | null;
  ContainerType_Value: string | null;
  DeliveryWeek: string | null;
  ERPDocumentLineGuid: string | null;
  CreatedOn: string | null;
  ContainerGuid: string | null;
  LineNo: string | null;
  Condition: string | null;
  IssuedToClientGuid: string | null;
  VersionValueAlu: string | null;
  Quantity: number | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  UoM_Id: string | null;
  UpdatedBy_UserFullname: string | null;
  ProjectTitle: string | null;
  ContainerType_Id: string | null;
  ClosedOn: string | null;
  ClosedBy_ClientTitle: string | null;
  Tag: string | null;
  ProjectGuid: string | null;
  ClosedBy: string | null;
  AcceptanceStatus_Value: string | null;
  OrderDetail?: Order | null;
  ProjectDetail?: Project | null;
  FormDetail?: Form | null;
  TimeRecordsDetails?: Array<TimeRecord>;
  DocumentationMappingDetails?: Array<DocumentationMappings>;
  ProductDetail?: Product | null;
  OriginDocumentationDetail?: Documentation | null;
  DocumentationDetails?: Array<Documentation>;
  FileDetails?: Array<File>;
  ComponentDetail?: Component | null;
  FileMappingDetails?: Array<FileMapping>;
  NoteDetails?: Array<Note>;
}

export interface ContactPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  ContactDetail?: Contact | null;
}

export interface AppointmentRequest {
  Status: AppointmentRequestStatusType;
  CreatedBy: string | null;
  ClientGuid: string;
  CreatedOn: string | null;
  Guid: string;
  AppointmentGuid: string;
  AppointmentDetail?: Appointment | null;
}

export interface DocumentationPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  DocumentationDetail?: Documentation | null;
}

export interface ERPAppointment {
  IssuedToClientGuid: string | null;
  Language_Value: string | null;
  Description: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  OrderId: string | null;
  AppointmentDate: string | null;
  ReferenceGuid: string | null;
  Language_Id: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  IssuedToClientTitle: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Type_Value: string | null;
  AppointmentWeek: string | null;
  Type_Id: string | null;
  ERPDocumentDetail?: ERPDocument | null;
}

export interface ComponentInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ComponentPermission | null;
  ComponentDetail?: Component | null;
}

export interface ProjectPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ProjectPermission | null;
}

export interface OrderLabel {
  Language_Id: string | null;
  UpdatedBy: string | null;
  Language_Value: string;
  CreatedBy: string | null;
  ClientGuid: string | null;
  FontColor: string;
  IconFileGuid: string | null;
  UpdatedOn: string | null;
  Text: string;
  Guid: string | null;
  CreatedOn: string | null;
  BackgroundColor: string;
  OrderLabelTextDetails?: Array<OrderLabelText>;
}

export interface ERPTime {
  Sys_IsDeleted: number | null;
  Sys_CreatedBy: string | null;
  Sys_DeletedOn: string | null;
  WorkstationNumber: number | null;
  Guid: string;
  HourlyRate: number | null;
  Workstation: string;
  ReferenceGuid: string | null;
  CostCenterText: string | null;
  PresentMinutes: number | null;
  Sys_UpdatedBy: string | null;
  Workers: number | null;
  TimeId: string | null;
  Sys_CreatedOn: string | null;
  Sys_UpdatedOn: string | null;
  Sys_DeletedBy: string | null;
  CostCenterNumber: string | null;
  ERPDocumentLineDetail?: ERPDocumentLine | null;
}

export interface FormInput {
  Description: string | null;
  Language_Value: string | null;
  ForAcceptance: number | null;
  ProductCategory_Id: string | null;
  IsUsedExternally: boolean | null;
  Guid: string | null;
  ProductCategory_Value: string | null;
  InstanceGuid: string | null;
  IsMandatory: number | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  FormGuid: string | null;
  Sys_DeletedBy: string | null;
  IsUsedInternally: boolean | null;
  Type_Id: string | null;
  Sys_IsDeleted: number | null;
  ParentId: string | null;
  Position: number | null;
  Sys_DeletedOn: string | null;
  ObjectType_Value: string | null;
  Title: string | null;
  Sid: string | null;
  Language_Id: string | null;
  ObjectType_Id: string | null;
  ParentSid: string | null;
  Type_Value: string | null;
  VariantGuid: string | null;
  ParentDetail?: FormInput | null;
  FormDetail?: Form | null;
  FormLanguageDetails?: Array<FormInputLanguage>;
  ChildrenDetails?: Array<FormInput>;
  FormInputPropDetails?: Array<FormInputProp>;
}

export interface DocumentationMappings {
  InstanceGuid: string | null;
  DocumentationGuid: string | null;
  InstanceType_Id: string | null;
  Guid: string | null;
  InstanceType_Value: string | null;
  OrderLineDetail?: OrderLine | null;
  DocumentationDetail?: Documentation | null;
}

export interface Note {
  Description: string | null;
  InstanceTypeType_Value: string | null;
  Status_Id: string | null;
  CreatedBy_ClientGuid: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  Guid: string;
  Status_Value: string | null;
  InstanceGuid: string | null;
  InstanceTypeType_Id: string | null;
  AssignedOn: string | null;
  CreatedBy_UserLastname: string | null;
  AssignedBy_UserFullname: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  AssignedBy: string | null;
  Type_Id: string | null;
  IssuedToClientGuid: string | null;
  CreatedBy: string | null;
  InstanceId: string | null;
  Title: string | null;
  CreatedBy_UserFullname: string | null;
  IssuedToUserGuid: string | null;
  KlaesId: string | null;
  Date: string | null;
  AssignedTo: string | null;
  AssignedTo_UserFullname: string | null;
  InstanceType_Id: string | null;
  IssuedToClientTitle: string | null;
  InstanceTitle: string | null;
  InstanceType_Value: string | null;
  Type_Value: string | null;
  OrderDetail?: Order | null;
  ProjectDetail?: Project | null;
  UserDetail?: User | null;
  NoteDetails?: Array<Note>;
  OrderLineDetail?: OrderLine | null;
  NoteDetail?: Note | null;
  InstanceActionDetails?: Array<NoteInstanceAction>;
  DocumentationDetail?: Documentation | null;
  PermissionDetails?: Array<NotePermission>;
  FileDetails?: Array<File>;
  ComponentDetail?: Component | null;
  FileMappingDetails?: Array<FileMapping>;
}

export interface Contact {
  Zip: string | null;
  Company: string | null;
  HouseNumber: string | null;
  Email: string | null;
  Description: string | null;
  Telephone: string | null;
  ContactType_Id: string | null;
  CreatedBy_ClientGuid: string | null;
  Country_Id: string | null;
  AddressTitle: string | null;
  Latitude: number | null;
  Guid: string;
  Country_Value: string | null;
  InstanceGuid: string | null;
  AddressDescription: string | null;
  Salutation_Id: string | null;
  Street: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  LanguageValue: string | null;
  IssuedToClientGuid: string | null;
  Designation: string | null;
  UseContainerAddress: number | null;
  Lastname: string | null;
  ContactType_Value: string | null;
  IssuedToUserGuid: string | null;
  City: string | null;
  Longitude: number | null;
  Mobile: string | null;
  Firstname: string | null;
  ImageGuid: string | null;
  InstanceType_Id: string | null;
  IssuedToClientTitle: string | null;
  Region: string | null;
  Country: string | null;
  Salutation_Value: string | null;
  InstanceType_Value: string | null;
  Fax: string | null;
  LanguageId: string | null;
  Place: string | null;
  OrderDetail?: Order | null;
  ProjectDetail?: Project | null;
  PartnerDetails?: Array<ContactPartner>;
  InstanceActionDetails?: Array<ContactInstanceAction>;
  ContainerDetails?: Array<Container>;
}

export interface ApplicationConfiguration {
  ConfigurationId: string | null;
  ApplicationDescription: string | null;
  Sid: string | null;
  ConfigurationTitle: string | null;
  ConfigurationImageName: string | null;
  Counter: number | null;
  ConfigurationDescription: string | null;
  Value: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Type_Value: string | null;
  ApplicationId: string | null;
  Type_Id: string | null;
}

export interface DocumentationInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  DocumentationDetail?: Documentation | null;
  PermissionDetail?: DocumentationPermission | null;
}

export interface ContainerPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  ContainerDetail?: Container | null;
}

export interface ERPFitting {
  Language_Value: string | null;
  Length2UOM_Value: string | null;
  OrderNumber: string | null;
  SortingIndicator: string | null;
  Guid: string | null;
  FittingId: string | null;
  CasementId: string | null;
  ReferenceGuid: string | null;
  ArticleTypeText: string | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  Length1UOM_Id: string | null;
  UpdatedOn: string | null;
  Length1: number | null;
  CreatedOn: string | null;
  ArticleType_Id: string | null;
  Length2: number | null;
  ElementId: string | null;
  Type_Id: string | null;
  ArticleType_Value: string | null;
  IssuedToClientGuid: string | null;
  OrderNumberText: string | null;
  IssuedToUserGuid: string | null;
  OrderId: string | null;
  TypeText: string | null;
  Length1UOM_Value: string | null;
  Language_Id: string | null;
  Manufacturer_Id: string | null;
  IssuedToClientTitle: string | null;
  Length2UOM_Id: string | null;
  Manufacturer_Value: string | null;
  Type_Value: string | null;
  DocumentLineId: string | null;
  ManufacturerText: string | null;
  ERPCoverFrameDetail?: ERPCoverFrame | null;
  ERPCasementDetail?: ERPCasement | null;
}

export interface ClientPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ClientPermissionAction>;
  ClientDetail?: Client | null;
}

export interface OrderTeamMapping {
  DeletedBy: string | null;
  TeamTitle: string | null;
  OrderGuid: string | null;
  CreatedBy: string | null;
  TeamGuid: string | null;
  DeletedOn: string | null;
  Guid: string;
  OrderTitle: string | null;
  UpdatedBy: string | null;
  ClientGuid: string | null;
  TeamDescription: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  OrderDetail?: Order | null;
  TeamDetail?: Team | null;
  OrderResourceDetails?: Array<OrderResourceMapping>;
  FileDetails?: Array<File>;
}

export interface ClientModule {
  MaxPropagationLevel: number | null;
  Taker: string;
  ValidTill: string | null;
  ValidFrom: string;
  Guid: string;
  Type_Value: string;
  Licensee: string;
  Type_Id: string;
}

export interface AppointmentConfig {
  CalendarTypeValue: string;
  ClientGuid: string | null;
  CalendarTypeId: string;
  UpdatedOn: string | null;
  Guid: string;
  CreatedOn: string | null;
  UserGuid: string | null;
  AppointmentConfigPropertyDetails?: Array<AppointmentConfigProperty>;
}

export interface FileInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: FilePermission | null;
  FileDetail?: File | null;
}

export interface ClientInvitationToken {
  NewClientFax: string | null;
  ShowClientInWinDoPass: boolean | null;
  InvitedByPartnerService: boolean | null;
  InvitedByClientGuid: string | null;
  NewClientZip: string | null;
  CreatedBy_ClientGuid: string | null;
  NewClientCountry_Value: string | null;
  NewUserEmail: string | null;
  Guid: string | null;
  NewUserLanguageValue: string | null;
  ClientTypeValue: ClientType | null;
  UpdatedBy: string | null;
  NewClientHouseNumber: string | null;
  NewUserFirstname: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  NewClientTelephone: string | null;
  CreatedBy: string | null;
  ClientId: string | null;
  NewClientStreet: string | null;
  NewClientTitle: string | null;
  ClientType_Id: string | null;
  NewClientCity: string | null;
  UserInvitationTokenGuid: string | null;
  ValidUntil: string | null;
  NewClientCountry_Id: string | null;
  NewUserLastname: string | null;
  UserInvitationTokenDetail?: UserInvitationToken | null;
}

export interface ErpConfig {
  UpdatedBy: string | null;
  TypeId: string;
  Description: string | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  IsActive: boolean | null;
  TypeValue: string;
  Value: string;
  UpdatedOn: string | null;
  Guid: string | null;
  CreatedOn: string | null;
}

export interface OrderPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: OrderPermission | null;
}

export interface OrderOrderLabelMapping {
  UpdatedBy: string | null;
  OrderGuid: string;
  CreatedBy: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  OrderLabelGuid: string;
  OrderDetail?: Order | null;
  OrderLabelDetail?: OrderLabel | null;
}

export interface Container {
  IssuedToClientGuid: string | null;
  Description: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  PartnerGuid: string | null;
  IsRented: number | null;
  ImageGuid: string | null;
  IsRentable: number | null;
  IssuedToClientTitle: string | null;
  UpdatedOn: string | null;
  ContactGuid: string | null;
  CreatedOn: string | null;
  ContainerGuid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PartnerDetails?: Array<ContainerPartner>;
  ProductDetails?: Array<Product>;
  ContactDetails?: Array<Contact>;
  InstanceActionDetails?: Array<ContainerInstanceAction>;
  DocumentationDetails?: Array<Documentation>;
}

export interface ComponentLanguage {
  IsDefault: number | null;
  IssuedToClientGuid: string | null;
  CreatedBy: string | null;
  Language_Value: string | null;
  TextShort: string | null;
  CreatedBy_ClientGuid: string | null;
  CreatedBy_UserFirstname: string | null;
  CreatedBy_UserGuid: string | null;
  CreatedBy_UserFullname: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  TextLong: string | null;
  Language_Id: string | null;
  TranslationCount: number | null;
  InstanceGuid: string | null;
  ClientGuid: string | null;
  CreatedBy_UserLastname: string | null;
  Note: string | null;
  IssuedToClientTitle: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  CustomerText: string | null;
  ComponentDetail?: Component | null;
  FileDetails?: Array<File>;
}

export interface ContentCenterText {
  UpdatedBy: string | null;
  Description: string | null;
  CreatedBy: string;
  ContentCenterGuid: string;
  UpdatedOn: string | null;
  Title: string;
  Guid: string;
  CreatedOn: string | null;
  LanguageValue: string;
  LanguageId: string;
  ContentCenterDetail?: ContentCenter | null;
  FileMappingDetails?: Array<FileMapping>;
}

export interface ProductInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ProductPermission | null;
  ProductDetail?: Product | null;
}

export interface ValueHelp {
  TextShort: string;
  IconFileGuid: string | null;
  Guid: string | null;
  TextLong: string | null;
  Ranking: number;
  ClientGuid: string | null;
  Value: string;
  UpdatedOn: string | null;
  IsExpandable: number | null;
  CreatedOn: string;
  Id: string;
  LanguageValue: string;
  LanguageId: string;
  IconDetails?: File | null;
  RuleDetails?: Array<Rule>;
  FileMappingDetails?: Array<FileMapping>;
  FileDetails?: Array<File>;
  ValueHelpTextDetails?: Array<ValueHelpText>;
}

export interface FormInputPropLanguage {
  Language_Id: string | null;
  DefaultValue: string | null;
  Description: string | null;
  InstanceGuid: string | null;
  Language_Value: string | null;
  Position: number | null;
  Title: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string | null;
  VariantGuid: string | null;
  FormInputGuid: string | null;
  FormInputPropDetail?: FormInputProp | null;
}

export interface ValueHelpText {
  Ranking: number | null;
  TextShort: string;
  ClientGuid: string | null;
  Value: string;
  UpdatedOn: string | null;
  ValueHelpGuid: string;
  CreatedOn: string;
  Guid: string;
  TextLong: string | null;
  LanguageValue: string;
  LanguageId: string;
  ValueHelpDetail?: ValueHelp | null;
}

export interface RuleOption {
  UpdatedBy: string | null;
  InstanceGuid: string | null;
  CreatedBy: string | null;
  Check_Id: string | null;
  Value: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  Check_Value: string | null;
  RuleDetail?: Rule | null;
}

export interface ResourcePermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: ResourcePermission | null;
}

export interface AppointmentConfigProperty {
  UpdatedBy: string | null;
  DisplayOrder: number;
  CreatedBy: string | null;
  PropertyValue: string;
  UpdatedOn: string | null;
  Guid: string;
  CreatedOn: string | null;
  AppointmentConfigGuid: string;
  LineNumber: number;
  PropertyId: string;
  AppointmentConfigDetail?: AppointmentConfig | null;
}

export interface AppointmentPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<AppointmentPermissionAction>;
}

export interface ERPCasement {
  DesignTextAlu: string | null;
  DesignValueAlu: string | null;
  HandlePositionText: string | null;
  Language_Value: string | null;
  Design_Text: string | null;
  Type_Text: string | null;
  Guid: string | null;
  DesignExterior_Value: string | null;
  CasementId: string | null;
  ReferenceGuid: string | null;
  GasketStopShortText: string | null;
  InstanceGuid: string | null;
  FittingParameter: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  DesignInterior_Text: string | null;
  Height: number | null;
  CasementIdDrawing: string | null;
  CreatedOn: string | null;
  DesignInterior_Value: string | null;
  Width: number | null;
  ElementId: string | null;
  IssuedToClientGuid: string | null;
  TypeValueAlu: string | null;
  GroupNumber: string | null;
  GasketStopLongText: string | null;
  IssuedToUserGuid: string | null;
  OrderId: string | null;
  Language_Id: string | null;
  Type: string | null;
  Design_Value: string | null;
  IssuedToClientTitle: string | null;
  DesignExterior_Text: string | null;
  DocumentLineId: string | null;
  HandlePosition_Value: string | null;
  TypeTextAlu: string | null;
  ERPGlassDetails?: Array<ERPGlass>;
  ERPFittingDetails?: Array<ERPFitting>;
  ERPCoverFrameDetail?: ERPCoverFrame | null;
}

export interface ERPDocument {
  Language_Value: string | null;
  Guid: string | null;
  Remark: string | null;
  ReferenceGuid: string | null;
  CreatorText: string | null;
  ClientName: string | null;
  InstanceGuid: string | null;
  TourNumber: string | null;
  ClientGuid: string | null;
  EditorText: string | null;
  ClientId: string | null;
  UpdatedOn: string | null;
  LanguageText: string | null;
  CreatedOn: string | null;
  DeliveryOn: string | null;
  ProjectDescription: string | null;
  Type_Id: string | null;
  IssuedToClientGuid: string | null;
  UnassignedProductsCount: number | null;
  CreatorId: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  EditorId: string | null;
  PurchaseRemark: string | null;
  OrderId: string | null;
  PartnerGuid: string | null;
  FactoryId: string | null;
  Language_Id: string | null;
  ProjectTitle: string | null;
  OrderTypeValue: string | null;
  IssuedToClientTitle: string | null;
  ProcessId: string | null;
  Type_Value: string | null;
  Memo: string | null;
  UnassignedComponentsCount: number | null;
  PdfFileGuid: string | null;
  ComponentDetails?: Array<Component>;
  ProductDetails?: Array<Product>;
  ERPAppointmentDetails?: Array<ERPAppointment>;
  ERPAddressDetails?: Array<ERPAddress>;
  ERPDocumentLineDetails?: Array<ERPDocumentLine>;
  ERPAddressDeliveryDetails?: Array<ERPAddressDelivery>;
}

export interface PartnerDataPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<PartnerDataPermissionAction>;
  PartnerDataDetail?: PartnerData | null;
}

export interface Role {
  ClientGuid: string | null;
  UserGuid: string | null;
  UpdatedOn: string | null;
  RoleId: string | null;
  Sid: string | null;
  UserDetail?: User | null;
}

export interface ComponentLabel {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  Text: string;
  Guid: string | null;
  CreatedOn: string | null;
  FileMappingDetails?: Array<FileMapping>;
  FileDetails?: Array<File>;
  RuleDetails?: Array<Rule>;
}

export interface PartnerDataInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: PartnerDataPermission | null;
  PartnerDataDetail?: PartnerData | null;
}

export interface OrderPartner {
  IssuedToClientGuid: string | null;
  InstanceGuid: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Type_Value: string | null;
  PartnerGuid: string | null;
  Type_Id: string | null;
  Sid: string | null;
  OrderDetail?: Order | null;
}

export interface InstancePartnerProject {
  IssuedToClientGuid: string | null;
  Description: string | null;
  InstanceGuid: string | null;
  ProjectTitle: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  PartnerGuid: string | null;
  Sid: string | null;
}

export interface UserConfiguration {
  IsDeleted: number | null;
  Counter: number | null;
  UserGuid: string | null;
  IsActive: number | null;
  Value: string | null;
  ConfigurationDescription: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  ApplicationId: string | null;
  ConfigurationId: string | null;
  ApplicationDescription: string | null;
  Sid: string | null;
  UserDetail?: User | null;
}

export interface ProjectInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  ProjectDetail?: Project | null;
  PermissionDetail?: ProjectPermission | null;
}

export interface Team {
  DeletedBy: string | null;
  IssuedToClientGuid: string | null;
  Description: string | null;
  CreatedBy: string | null;
  CreatedBy_ClientGuid: string | null;
  DeletedOn: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  AssignedTo: string | null;
  UpdatedBy: string | null;
  AssignedOn: string | null;
  ClientGuid: string | null;
  Color_Value: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  AssignedBy: string | null;
  OrderTeamDetails?: Array<OrderTeamMapping>;
  AppointmentDetails?: Array<Appointment>;
  TeamMemberDetails?: Array<TeamMember>;
  InstanceActionDetails?: Array<TeamInstanceAction>;
  PermissionDetails?: Array<TeamPermission>;
  FileDetails?: Array<File>;
}

export interface AppointmentPermissionAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  PermissionDetail?: AppointmentPermission | null;
}

export interface InvitationRule {
  InvitableClientType_Id: string | null;
  InvitableUserType_Id: string | null;
  InvitableUserType_Value: string | null;
  InvitableClientType_Value: string | null;
  Sid: string | null;
}

export interface TeamPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<TeamPermissionAction>;
  TeamDetail?: Team | null;
}

export interface ProductLanguage {
  IsDefault: number | null;
  ExtLaminationCol: string | null;
  Condition: string | null;
  IssuedToClientGuid: string | null;
  ExtBaseCol: string | null;
  CreatedBy: string | null;
  Language_Value: string | null;
  Description: string | null;
  CreatedBy_ClientGuid: string | null;
  ExtType: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  Guid: string;
  ExtSealCol: string | null;
  Name: string | null;
  Language_Id: string | null;
  InstanceGuid: string | null;
  ExtText: string | null;
  IssuedToClientTitle: string | null;
  UpdatedOn: string | null;
  ERPCustomerText: string | null;
  CreatedOn: string | null;
  InstanceActionDetails?: Array<ProductTextInstanceAction>;
  PermissionDetails?: Array<ProductTextPermission>;
  ProductDetail?: Product | null;
}

export interface ContactPermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<ContactPermissionAction>;
}

export interface ProductTextInstanceAction {
  IssuedToClientGuid: string | null;
  PermissionGuid: string | null;
  InstanceGuid: string | null;
  IssuedToUserGuid: string | null;
  Guid: string | null;
  Type_Value: string | null;
  Type_Id: string | null;
  ProductLanguageDetail?: ProductLanguage | null;
  PermissionDetail?: ProductTextPermission | null;
}

export interface FilePermission {
  InstanceGuid: string | null;
  CreatedBy_ClientGuid: string | null;
  IssuedTo_UserFullname: string | null;
  CreatedBy_UserGuid: string | null;
  IssuedTo_UserGuid: string | null;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  IssuedTo_ClientTitle: string | null;
  Guid: string | null;
  IssuedTo_ClientGuid: string | null;
  ActionDetails?: Array<FilePermissionAction>;
  FileDetail?: File | null;
}

export interface Project {
  Zip: string | null;
  Email: string | null;
  CreatedBy_ClientGuid: string | null;
  Status_Id: string | null;
  CreatedBy_UserFirstname: string | null;
  AddressTitle: string | null;
  Country_Id: string | null;
  Latitude: number | null;
  Guid: string | null;
  ContactPerson: string | null;
  Status_Value: string | null;
  Remark: string | null;
  AddressType_Id: string | null;
  CreatedBy_UserLastname: string | null;
  Street: string | null;
  UpdatedOn: string | null;
  ContactPersonEmail: string | null;
  AddressType_Value: string | null;
  CreatedBy: string | null;
  Lastname: string | null;
  City: string | null;
  KlaesId: string | null;
  OrderId: string | null;
  Longitude: number | null;
  PartnerGuid: string | null;
  ImageFileGuid: string | null;
  AddressGuid: string | null;
  Region: string | null;
  ContactPersonTelephone: string | null;
  HouseNumber: string | null;
  Description: string | null;
  SalutationId: string | null;
  Name02: string | null;
  Country_Value: string | null;
  Name01: string | null;
  AddressDescription: string | null;
  Phone: string | null;
  ContainerType_Value: string | null;
  CreatedOn: string | null;
  ContainerGuid: string | null;
  IssuedToClientGuid: string | null;
  CreatedBy_ClientTitle: string | null;
  Title: string | null;
  IssuedToUserGuid: string | null;
  CountNoteDetails: number | null;
  SalutationValue: string | null;
  Firstname: string | null;
  ContainerType_Id: string | null;
  ProcessId: string | null;
  Place: string | null;
  OrderDetails?: Array<Order>;
  ProductDetails?: Array<Product>;
  AddressDetail?: Address | null;
  InstanceActionDetails?: Array<ProjectInstanceAction>;
  OrderLineDetails?: Array<OrderLine>;
  FileDetails?: Array<File>;
  FileMappingDetails?: Array<FileMapping>;
  LogoDetail?: File | null;
  ComponentDetails?: Array<Component>;
  PartnerDetails?: Array<ProjectPartner>;
  ContactDetails?: Array<Contact>;
  PermissionDetails?: Array<ProjectPermission>;
  DocumentationDetails?: Array<Documentation>;
  NoteDetails?: Array<Note>;
}

export interface FormSignature {
  TypeId: string;
  UpdatedBy: string | null;
  IsRequired: boolean | null;
  CreatedBy: string | null;
  TypeValue: string;
  UpdatedOn: string | null;
  CreatedOn: string | null;
  Guid: string;
  FormGuid: string;
  FormDetail?: Form | null;
}

export interface ProductLabel {
  UpdatedBy: string | null;
  CreatedBy: string | null;
  ClientGuid: string | null;
  UpdatedOn: string | null;
  Text: string;
  Guid: string | null;
  CreatedOn: string | null;
  FileMappingDetails?: Array<FileMapping>;
  FileDetails?: Array<File>;
  RuleDetails?: Array<Rule>;
}
